import React from "react";
import styles from "./css/Rodape.module.css";
import { FaInstagram, FaLinkedin, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import logoHL from "../../assets/images/logo hl software ( letra banca ).png";
import { Link } from "react-router-dom";
import { useNavClick } from "../Header/navHelpers";



export default function Rodape() {
    const handleNavClick = useNavClick();

    return (
        <footer className={styles.rodape}>
            <div className={styles.topo}>
                <div className={styles.logoArea}>
                    <img src={logoHL} alt="HL Software" className={styles.logo} />
                    <p className={styles.slogan}>Transformando ideias em tecnologia</p>
                </div>

                <div className={styles.grid}>
                    <div className={styles.col}>
                        <h4>Páginas</h4>
                        <a href="/#inicio" onClick={(e) => handleNavClick(e, "/#inicio")}>Início</a>
                        <a href="/#produtos" onClick={(e) => handleNavClick(e, "/#produtos")}>Produtos</a>
                        <a href="https://gestortx.com" target="_blank" rel="noopener noreferrer">Gestor Tx</a>
                        <Link to="/blog">Blog</Link>
                        <a href="/#contato" onClick={(e) => handleNavClick(e, "/#contato")}>Contato</a>
                    </div>

                    {/*<div className={styles.col}>
                        <h4>Trabalhe Conosco</h4>
                        <a href="/vagas">Ver vagas</a>
                    </div>*/}

                    <div className={styles.col}>
                        <h4>Contato</h4>
                        <p><FaEnvelope /> contato@hlsoftware.com</p>
                        <p><FaWhatsapp /> (81) 9.9438-0956</p>
                    </div>

                    <div className={styles.col}>
                        <h4>Redes Sociais</h4>
                        <div className={styles.socialIcons}>
                            <a href="https://www.instagram.com/hlsoftware/" target="_blank" rel="noreferrer">
                                <FaInstagram />
                            </a>
                            <a href="https://www.linkedin.com/company/hlsoftware" target="_blank" rel="noreferrer">
                                <FaLinkedin />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.base}>
                <div className={styles.linksLegais}>
                    <Link to="/politica-de-privacidade">Política de Privacidade</Link>
                    <Link to="/termos-de-uso">Termos de Uso</Link>
                </div>
                <p className={styles.copy}>
                    © {new Date().getFullYear()} HL Software. Todos os direitos reservados.
                </p>
            </div>
        </footer>
    );
}
